import gql from "graphql-tag";

/**
 * GraphQL query to obtain information about the current connection / session in local state.
 *
 * This query should be local and never query the server.
 */
export default gql`
  query {
    ConnectionInfo @client {
      appUrl
      authenticated
      authorizationFailed
      errorMessage
      locale
      connectionLost
      menuVisible
    }
  }
`;
